module.exports = __webpack_public_path__ + "static/img/app5.3322e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app5.jpg
// module id = nrfC
// module chunks = 1